import { NgModule } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { CustomerRoutingModule } from './customer-routing.module';
import { CommonCloudStudioModule } from 'common-cloudstudio';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { SharedModule } from 'src/app/customer-modules/apolus/shared/shared.module';
import { LiteralsResolver } from 'src/app/customer-modules/apolus/shared/guards/literals.guard';
import { ActionsComponent } from 'src/app/customer-modules/apolus/actions/actions.component';
import { DataTableComponent } from 'src/app/customer-modules/apolus/actions/table/table.component';
import { ModalBatchDevicesComponent } from 'src/app/customer-modules/apolus/actions/modal-batch-devices/modal-batch-devices.component';
import { DashboardCustomerModule } from 'src/app/customer-modules/apolus/dashboard/dashboard.module';
import { UsersModule } from 'src/app/customer-modules/apolus/users/users.module';
import { MapsCustomModule } from 'src/app/customer-modules/apolus/maps/maps.module';
import { ReportsComponent } from 'src/app/customer-modules/apolus/reports/reports.component';

@NgModule({
  declarations: [
    ActionsComponent,
    ReportsComponent,
    DataTableComponent,
    ModalBatchDevicesComponent,
  ],
  exports: [],
  imports: [
    CommonModule,
    CustomerRoutingModule,
    ReactiveFormsModule,
    AccordionModule.forRoot(),
    FormsModule,
    SharedModule,
    CommonCloudStudioModule,
    TooltipModule.forRoot(),
    BsDropdownModule.forRoot(),
    UsersModule,
    MapsCustomModule,
    DashboardCustomerModule
  ],
  providers: [
    LiteralsResolver
  ]
})
export class CustomerModule {
  constructor(
    private literalGuard: LiteralsResolver,
  ) {}

  async AssetTrackingTabs(): Promise<any[]> { return; }
}
